<template>
   <button class="btn btn-transparent border-0 text-primary w-100 mt-3 " style="text-align:right" data-bs-toggle="offcanvas" data-bs-target="#cardoffcanvasBottom" aria-controls="cardoffcanvasBottom"><img src="https://radap.ir/imagesUploaded/card/info.png" width="20" class="ml-1"/>اطلاع از جوایز ماهانه</button>
    
    <div class="offcanvas offcanvas-bottom" tabindex="-1" id="cardoffcanvasBottom" aria-labelledby="cardoffcanvasBottomLabel" style="z-index: 99999;">
      <div class="offcanvas-header">
        <h6 class="offcanvas-title text-dark" id="cardoffcanvasBottomLabel" style="display: flex;align-items: center;font-weight: 700;"><img src="https://radap.ir/imagesUploaded/card/star.png" width="50">با تراکنش در راداَپ ماهانه جایزه بگیر!</h6>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body small text-dark">
        <div>
            با خرید شارژ واینترنت مصرفی روزمره از راداَپ به نسبت تراکنشتون ماهانه هدیه بگیرید
            شارژ هدیه با توجه به خریدتون متغیر هست
            تراکنش‌های شما در طول ماه جمع شده و در آخرین روز هر ماه محاسبه وشروع مبلغ جایزه  از 5,000 تومان تا سقف 50,000 تومان قابل تغییر است،و طبق سیستم جایزه فقط به شماره ایی که شارژ و اینترنت خریداری میکند تعلق میگیره
            و از طریق پیامک به شما اعلام میشه.
        </div>
        <button class="btn btn-outline-success text-dark w-100 mt-1" type="button" data-bs-dismiss="offcanvas">متوجه شدم</button>
      </div>
    </div>
</template>
   